import { QuestionCircleOutlined } from '@ant-design/icons'
import { Button, Modal } from 'antd'
import { useState } from 'react'

type HowDoesItWorkButtonProps = {
  demoUrl: string
}

export function HowDoesItWorkButton({ demoUrl }: HowDoesItWorkButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <Button
        onClick={() => setIsModalOpen(true)}
        size="large"
        icon={<QuestionCircleOutlined />}
      >
        How does it work?
      </Button>

      <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        style={{ top: 40 }}
        styles={{
          body: {
            height: '80vh',
            paddingTop: 10,
            paddingBottom: 10,
          },
        }}
        destroyOnClose
      >
        <iframe
          src={demoUrl + '?embed&embed_mobile=inline&embed_desktop=inline'}
          title="Your AI Employees who love overtime"
          frameBorder="0"
          loading="lazy"
          allowFullScreen
          allow="clipboard-write"
          style={{
            position: 'absolute',
            top: 0,
            paddingTop: 10,
            paddingBottom: 10,
            left: 0,
            width: '100%',
            height: '100%',
            border: 'none',
          }}
        />
      </Modal>
    </>
  )
}
